import services from '../../../../services';
import * as types from './client-action-types';

const api = services.coreAPIInstance;

export const fetchClientData = () => (dispatch) => {
    dispatch({ type: types.FETCHING_CLIENT_DATA });

    return api.getClientData()
        .then(data => {
            dispatch({
                type: types.RECEIVE_CLIENT_DATA,
                payload: data
            });
            return data;
        })
        .catch(error => {
            dispatch({
                type: types.FETCH_CLIENT_ERROR,
                error
            });
            throw error;
        });
};
